import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ie-custom-6",
  "use": "icon-ie-custom-6-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ie-custom-6\">\r\n    <path d=\"M116.4921875 229.48572752A112.99354002 112.99354002 0 0 1 229.48572752 116.4921875h565.02854497A112.99354002 112.99354002 0 0 1 907.5078125 229.48572752v565.02854497A112.99354002 112.99354002 0 0 1 794.51427248 907.5078125H229.48572752A112.99354002 112.99354002 0 0 1 116.4921875 794.51427248V229.48572752z\" fill=\"#FFC900\" p-id=\"2822\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol